import { makeStyles } from '@material-ui/core';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import React from 'react';

const useStyles = makeStyles(theme => ({
  archiveDialogIcon: {
    width: 75,
    height: 75,
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    color: theme.palette.error.main,
  },
}));

export default function DeleteDialogIcon() {
  const classes = useStyles();

  return <DeleteForeverRoundedIcon className={`${classes.archiveDialogIcon} my-2`} />;
}
